import { styled } from 'styled-components'

const NoAccessMessage = () => <Message>You don't have permission to access this page.</Message>

export default NoAccessMessage

const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
`
